<!--<header class="m-grid__item m-header " m-minimize="minimize" m-minimize-mobile="minimize" m-minimize-offset="200" m-minimize-mobile-offset="200">-->
<!--  <div class="m-container m-container&#45;&#45;fluid m-container&#45;&#45;full-height">-->
<!--    <div class="m-stack m-stack&#45;&#45;ver m-stack&#45;&#45;desktop  m-header__wrapper">-->
<!--      <div class="m-stack__item m-brand m-brand&#45;&#45;mobile">-->
<!--        <div class="m-stack m-stack&#45;&#45;ver m-stack&#45;&#45;general">-->
<!--          <div class="m-stack__item m-stack__item&#45;&#45;middle m-brand__logo">-->
<!--            <a routerLink="/audits" class="m-brand__logo-wrapper">-->
<!--              <img alt="Social auditor" height="30" src="assets/images/social-auditor-logo-black.png" />-->
<!--            </a>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="m-stack__item m&#45;&#45;margin-top-25">-->
<!--        <a routerLink="/audits" class="m-brand m-brand&#45;&#45;desktop">-->
<!--          <img alt="Social auditor" height="30" src="assets/images/social-auditor-logo-black.png" />-->
<!--        </a>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</header>-->


<div [ngClass]="!(isAnonymous() | async) ? 'mx-5 mt-6' : ''">
<!--<div class="container">-->
  <app-profile-audit type="demo"></app-profile-audit>
  <div *ngIf="(isAnonymous() | async)">
    <div class="fixed-info row m-0">
      <div class="col-lg-3 report-img mt-5">
        <img class="" src="assets/images/icons/report.png"/>
      </div>
      <div class="col-lg-6 col-md-9 mt-5">
        <p>This was sample PRO report.</p>
        <h3 class="mt-3">Would you like to see an extended report for your profile?</h3>
        <div class="pro-items my-5">
          <div class="pro-item">
            <div>
              <img src="assets/images/icons/age.png"/>
              <span class="blue-label">PRO</span>
            </div>
            <p>Age</p>
          </div>
          <div class="pro-item">
            <div>
              <img src="assets/images/icons/cities.png"/>
              <span class="blue-label">PRO</span>
            </div>
            <p>Localization</p>
          </div>
          <div class="pro-item">
            <div>
              <img src="assets/images/icons/gender.png"/>
              <span class="blue-label">PRO</span>
            </div>
            <p>Gender</p>
          </div>
          <div class="pro-item">
            <div>
              <img src="assets/images/icons/age.png"/>
              <span class="blue-label">PRO</span>
            </div>
            <p>Authenticity</p>
          </div>
          <div class="pro-item">
            <div>
              <img src="assets/images/icons/age.png"/>
              <span class="blue-label">PRO</span>
            </div>
            <p>Fake interactions</p>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-12 check-content text-center">
        <a class="btn btn-blue btn-blue-hover btn-lg" routerLink="/payment/add">Check pricing</a>
      </div>
    </div>
  </div>
</div>

<div class="fixed-info" *ngIf="!(isAnonymous() | async)">
  <form method="get" action="https://socialauditor.io/report">
    <input class="form-control" name="profile" type="text" placeholder="Profile name...">
    <button type="submit" class="btn btn-blue btn-blue-hover px-md-4 ml-2">
      Check
    </button>
  </form>
</div>
